var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    t: 1676655216252,
    className: "icon",
    "p-id": 23414,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m914.75,466.75l-82.75,-82.75l0,-128a64.19,64.19 0 0 0 -64,-64l-128,0l-82.75,-82.75a64.19,64.19 0 0 0 -90.51,0l-82.74,82.75l-128,0a64.19,64.19 0 0 0 -64,64l0,128l-82.75,82.75a64.19,64.19 0 0 0 0,90.51l82.75,82.74l0,128a64.19,64.19 0 0 0 64,64l128,0l82.75,82.75a64.19,64.19 0 0 0 90.51,0l82.74,-82.75l128,0a64.19,64.19 0 0 0 64,-64l0,-128l82.75,-82.75a64.19,64.19 0 0 0 0,-90.5zm-402.75,269.25l-192,-352l96,0l96,192l96,-192l96,0l-192,352z",
    "p-id": 23415,
    fill: "#efb336",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efb336",
    stroke: "null",
    opacity: "NaN",
    d: "m319.24999,382.99999l97.00001,0.75001",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efb336",
    stroke: "null",
    opacity: "NaN",
    d: "m319.24999,384.24999l126.03308,62.91988",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#efb336",
    stroke: "null",
    opacity: "NaN",
    d: "m320.70451,384.22653l89.35843,-1.20762l99.37108,194.33965l98.11322,-191.19499",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m318.55558,383.55558l91.44442,0.33331l100,193.88889l98.88889,-195.55556l95.55556,1.11111l-192.22222,352.22222l-193.66664,-351.99998z",
    opacity: "NaN",
    stroke: "#fff",
    fill: "#7f00ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.d71dcaa05bae093cf9d0c458299c5c0d.svg";
export { ForwardRef as ReactComponent };